import axios from 'axios'
import createAdapter from 'mobx-rest-axios-adapter'
import {apiClient} from 'mobx-rest'

import { providerAccounts } from "./model/providerAccounts";
import { DeviceFeatureSets } from "./model/deviceFeatureSets";
import { policyJobs } from "./model/policyJobs";
import { Devices } from "./model/devices"
import { Caf2 } from "./model/caf2"
import { Subscribers } from "./model/subscribers";
import { UserGroups } from "./model/userGroups";
import { UserAccounts } from "./model/userAccounts";
import { LoginSessions } from "./model/loginSessions";
import { SelectionQuery } from "./model/selectionQuery";
import { SystemTasks } from "./model/systemTasks";
import { Tasks } from "./model/tasks";
import { DeviceDataModelEditor } from "./model/deviceDataModelEditor";
import { UxDataTableEditor } from "./model/uxDataTableEditor";
import { UxDataTableEditorConfig } from "./model/uxDataTableEditorConfig";
import { NotificationMessages } from "./model/notificationMessages";



class ApiEndpoints {
    providerAccounts = new providerAccounts();
    deviceFeatureSets = new DeviceFeatureSets();
    policyJobs = new policyJobs();
    devices = new Devices();
    caf2 = new Caf2();
    subscribers = new Subscribers();
    userGroups = new UserGroups();
    userAccounts = new UserAccounts();
    loginSessions = new LoginSessions();
    selectionQuery = new SelectionQuery();
    systemTasks = new SystemTasks();
    deviceDataModelEditor = new DeviceDataModelEditor();
    tasks = new Tasks();
    uxDataTableEditor = new UxDataTableEditor();
    uxDataTableEditorConfig = new UxDataTableEditorConfig();
    notificationMessages = new NotificationMessages();
}

/*
 * examples:
 *   // Instantiate
 *   - let api = new TsmApi('/restapi');
 *   - let api = new TsmApi('/rest/tsmrestapiproxy');
 *   - let api = new TsmApi('/rest/tsmrestapiproxy', {headers: { Authorization: "Bearer 123123123"}});
 *   - let api = new TsmApi('/rest/tsmrestapiproxy', {headers: { Authorization: "Basic YWRtaW5Acm9vdGRvbWFpbjphZG1pbg==" }});
 *
 *   // Add GET query parameters:
 *   - api.devices.fetch({data: {domain: "rootdomain", limit: 10}}) // <baseurl>/devices?domain=rootdomain&limit=10
 *   - api.devices.fetch({data: {deviceId: 29, domain: "rootdomain", limit: 10}})
 *   - api.devices.fetch({data: {sn: "serialNumber", domain: "rootdomain", limit: 10}})
 *
 *   // Accessing POST results:
 *   - api.loginSessions.login.save({username: "admin@rootdomain", password: "admin"}).then((data) => {console.log(data)})
 *
 *   // Executing a task
 *   - api.devices.cpeId(19).tasks.featureSetDeviceTask.save(
 *           {deviceTaskId: "ipPingDiagTest", taskInput: {host: '8.8.8.8'}})
 *      .then((data) => { console.log(data.taskResultInfo.taskId)})
 *   - api.tasks.taskId(1606396214).featureSetDeviceTask.fetch()
 *      .then((data) => { console.log(data)} )
 *      .catch((data) => { console.log(data)} )
 */
export class TsmApi extends ApiEndpoints {
    constructor(apiPath, commonOptions, extraOptions, adapter=null) {
        super();
        if (!apiPath) {
            throw new Error('"apiPath" must be defined');
        }
        const options = {
            mode: 'no-cors',
            apiPath: apiPath,
            commonOptions: {
                qs: {indices: false},
                headers: {
                    // Authorization: `Bearer ${token}`
                    // "Content-Type": "application/json"
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                }
            }
        };
        Object.assign(options.commonOptions, commonOptions);
        Object.assign(options, extraOptions);
        adapter = adapter !== null ? adapter : createAdapter(axios);
        apiClient(adapter, options);
    }

    fixUploadProgress(obj) {
        const getOnUploadProgress = (obj) => (
            (ev) => {
                const progress = Math.floor((ev.loaded * 100) / ev.total);
                obj.uploadProgress = progress;
                return progress;
            }
        )

        axios.interceptors.request.use(config => ({
            ...config,
            onUploadProgress: getOnUploadProgress(obj),
        }));
    }
}

